"use strict";

(function () {
  var adpCustomPromoPopup = {};
  var $this;

  adpCustomPromoPopup = {
    sPrevious: window.scrollY,
    sDirection: "down",
    isAgeConfirmed: false,

    init: function () {
      $this = adpCustomPromoPopup;
      console.log("[Custom Promo Popup] Initializing...");
      $this.popupInit();
      $this.setupEvents();
    },

    setupEvents: function () {
      document.addEventListener("click", $this.handleButtonClick);
      document.addEventListener("keyup", $this.handleKeyPress);
      document.addEventListener("click", $this.handleOverlayClick);
    },

    popupInit: function () {
      document.addEventListener("scroll", $this.updateScrollDirection);

      var popups = document.querySelectorAll(".custom-promo-popup");
      console.log("[Custom Promo Popup] Found popups:", popups.length);
      if (popups.length) {
        popups.forEach($this.setupPopup);
      }
    },

    updateScrollDirection: function () {
      let scrollCurrent = window.scrollY;
      $this.sDirection = scrollCurrent > $this.sPrevious ? "down" : "up";
      $this.sPrevious = scrollCurrent;
    },

    setupPopup: function (popup) {
      if (!$this.isAllowPopup(popup)) {
        console.log(
          "[Custom Promo Popup] Popup blocked by frequency/cookies/session settings for ID:",
          popup.dataset.id,
        );
        return;
      }

      console.log(
        "[Custom Promo Popup] Popup allowed. Setting up triggers for ID:",
        popup.dataset.id,
      );

      var clickableItems = popup.querySelectorAll(
        "a, button, input[type='submit'], .custom-promo-popup-close",
      );
      clickableItems.forEach(function (btn) {
        btn.addEventListener("click", function (e) {
          $this.acceptPopup(popup);

          if (btn.closest(".custom-promo-popup-close")) {
            e.preventDefault();
            $this.closePopup(popup);
            return;
          }

          var href = btn.getAttribute("href");
          if (href && href !== "#" && !href.startsWith("javascript:")) {
            e.preventDefault();
            e.stopPropagation();
            $this.closePopup(popup);
            window.location.href = href;
          }
        });
      });

      var forms = popup.querySelectorAll("form");
      forms.forEach(function (form) {
        form.addEventListener("submit", function () {
          $this.acceptPopup(popup);
        });
      });

      if (window.Shopify && window.Shopify.designMode) {
        console.log("[Custom Promo Popup] Shopify Design Mode detected.");
        return;
      }

      $this.openTriggerPopup(popup);
    },

    handleButtonClick: function (e) {
      const target = e.target;
      const popup = target.closest(".custom-promo-popup");
      if (!popup) return;

      $this.acceptPopup(popup);

      const closeBtn = target.closest(".custom-promo-popup-close");
      if (closeBtn) {
        e.preventDefault();
        $this.closePopup(popup);
        return;
      }
    },

    handleKeyPress: function (e) {
      if (e.key === "Escape") {
        $this.closePopupsByAttribute("data-esc-close");
      }
      if (e.key === "F4") {
        $this.closePopupsByAttribute("data-f4-close");
      }
    },

    handleOverlayClick: function (e) {
      if (e.target.classList.contains("custom-promo-popup-overlay")) {
        $this.closePopupsByAttribute("data-overlay-close");
      }
    },

    closePopupsByAttribute: function (attribute) {
      var closeItems = document.querySelectorAll(
        `.custom-promo-popup-open[${attribute}="true"]`,
      );
      closeItems.forEach(function (popup) {
        $this.acceptPopup(popup);
        $this.closePopup(popup);
      });
    },

    isAllowPopup: function (popup) {
      if (window.Shopify && window.Shopify.designMode) {
        return true;
      }

      var id = popup ? popup.dataset.id : "";
      if (!id) return false;

      if (popup.dataset.mobileDisable === "true" && window.innerWidth <= 768) {
        return false;
      }

      var keySpecific = "custom-promo-popup-accept-" + id;
      if ($this.getCookie(keySpecific)) {
        return false;
      }
      try {
        if (localStorage.getItem(keySpecific)) {
          return false;
        }
      } catch (e) {}

      if (popup.dataset.reshowOnClose === "true") {
        return true;
      }

      try {
        if (sessionStorage.getItem("custom-promo-popup-closed-session-" + id)) {
          return false;
        }
      } catch (e) {}

      return true;
    },

    isAgePopupVisible: function () {
      const avadaPopup = document.querySelector(
        ".Avada-VerificationPopUp, [class*='Avada-VerificationPopUp-Container'], [class*='Avada-VerificationPopUp'], [id*='Avada-VerificationPopUp']",
      );
      if (avadaPopup) {
        const style = window.getComputedStyle(avadaPopup);
        const visible =
          style.display !== "none" &&
          style.visibility !== "hidden" &&
          parseFloat(style.opacity || "1") > 0;
        if (visible) return true;
      }

      const themeAge = document.querySelector(
        "age-verification-popup.modal--is-active, .age-verification-popup.modal--is-active, #AgeVerificationPopup.modal--is-active",
      );
      if (themeAge) {
        return true;
      }

      return false;
    },

    waitForAgeVerificationToClose: function (callback) {
      let called = false;
      const triggerCallback = function (reason) {
        if (called) return;
        called = true;
        $this.isAgeConfirmed = true;
        console.log(
          "[Custom Promo Popup] Age gate passed / confirmed. Reason:",
          reason || "Confirmed",
        );
        cleanup();
        callback();
      };

      let intervalId = null;
      let observer = null;

      const cleanup = function () {
        if (intervalId) clearInterval(intervalId);
        if (observer) observer.disconnect();
        document.removeEventListener(
          "age-verification:confirmed",
          triggerCallback,
        );
        document.removeEventListener("click", clickHandler, true);
        document.removeEventListener("touchend", clickHandler, true);
      };

      const clickHandler = function (e) {
        const target = e.target;
        if (!target) return;

        const isVisible = $this.isAgePopupVisible();
        const isAgeClick =
          isVisible ||
          target.classList.contains("Avada-VerificationPopUp-Button") ||
          target.classList.contains("Avada-VerificationPopUp-Button--submit") ||
          target.closest(".Avada-VerificationPopUp-Button") ||
          target.closest(".Avada-VerificationPopUp-Button--submit") ||
          target.closest("[class*='Avada-VerificationPopUp']") ||
          target.closest("[id*='Avada-VerificationPopUp']") ||
          target.hasAttribute("data-age-verification-popup-exit-button") ||
          target.closest("[data-age-verification-popup-exit-button]") ||
          target.closest("age-verification-popup") ||
          target.closest("#AgeVerificationPopup");

        if (isAgeClick) {
          console.log(
            "[Custom Promo Popup] Clicked Age Verification confirm button!",
          );
          setTimeout(function () {
            triggerCallback("Clicked Confirm Button");
          }, 200);
        }
      };

      document.addEventListener("click", clickHandler, true);
      document.addEventListener("touchend", clickHandler, true);
      document.addEventListener(
        "age-verification:confirmed",
        function () {
          triggerCallback("Custom Age Event Fired");
        },
        { once: true },
      );

      let checkCount = 0;
      let agePopupWasSeen = false;

      intervalId = setInterval(function () {
        checkCount++;
        const isVisible = $this.isAgePopupVisible();

        if (isVisible) {
          if (!agePopupWasSeen) {
            console.log(
              "[Custom Promo Popup] Avada Age Verification Modal detected on screen.",
            );
          }
          agePopupWasSeen = true;
        } else if (agePopupWasSeen) {
          console.log(
            "[Custom Promo Popup] Avada Age Verification Modal closed/hidden.",
          );
          triggerCallback("Age Modal Dismissed");
        } else if (checkCount >= 16) {
          // After 4 seconds (16 checks), if no Age Popup appeared on screen, proceed!
          console.log(
            "[Custom Promo Popup] No Age Verification Modal appeared within 4 seconds. Starting timer.",
          );
          triggerCallback("No Age Modal Found");
        }
      }, 250);

      try {
        observer = new MutationObserver(function () {
          const isVisible = $this.isAgePopupVisible();
          if (isVisible) {
            if (!agePopupWasSeen) {
              console.log(
                "[Custom Promo Popup] MutationObserver detected Age Verification Modal.",
              );
            }
            agePopupWasSeen = true;
          } else if (agePopupWasSeen) {
            console.log(
              "[Custom Promo Popup] MutationObserver detected Age Modal closed.",
            );
            triggerCallback("MutationObserver Modal Dismissed");
          }
        });
        observer.observe(document.body, {
          childList: true,
          subtree: true,
          attributes: true,
          attributeFilter: ["style", "class"],
        });
      } catch (e) {}
    },

    openTriggerPopup: function (popup) {
      var delay = parseFloat(popup.dataset.openDelayNumber || 0);
      console.log(
        "[Custom Promo Popup] Scheduled open delay (seconds):",
        delay,
      );

      const startTimer = function () {
        if (popup._openDelayTimer) clearTimeout(popup._openDelayTimer);
        console.log(
          "[Custom Promo Popup] Timer started! Will open in",
          delay,
          "seconds.",
        );
        popup._openDelayTimer = setTimeout(function () {
          console.log("[Custom Promo Popup] Opening popup now!");
          $this.openPopup(popup);
        }, delay * 1000);
      };

      $this.waitForAgeVerificationToClose(startTimer);
    },

    openPopup: function (popup) {
      if (!popup) return;
      if (popup.classList.contains("custom-promo-popup-open")) return;

      if (popup.dataset.bodyScrollDisable === "true") {
        document.body.classList.add("custom-promo-popup-scroll-hidden");
        document.documentElement.classList.add(
          "custom-promo-popup-scroll-hidden",
        );
      }

      popup.classList.add("custom-promo-popup-open");

      const overlay =
        popup.nextElementSibling &&
        popup.nextElementSibling.classList.contains(
          "custom-promo-popup-overlay",
        )
          ? popup.nextElementSibling
          : document.querySelector(".custom-promo-popup-overlay");

      if (overlay && popup.dataset.overlay === "true") {
        overlay.classList.add("custom-promo-popup-overlay-active");
      }

      let openAnim = popup.dataset.openAnimation || "customPopupOpenZoom";
      const popupWrap =
        popup.querySelector(".custom-promo-popup-wrap") || popup;

      popupWrap.classList.remove(
        "customPopupExitZoom",
        "customPopupExitSlide",
        "customPopupExitFade",
      );
      popupWrap.classList.add("custom-promo-popup-animated", openAnim);

      popupWrap.addEventListener(
        "animationend",
        function () {
          popupWrap.classList.remove("custom-promo-popup-animated", openAnim);
        },
        { once: true },
      );
    },

    closePopup: function (popup) {
      if (!popup || !popup.classList.contains("custom-promo-popup-open"))
        return;

      var id = popup.dataset.id;
      if (id && popup.dataset.reshowOnClose !== "true") {
        try {
          sessionStorage.setItem(
            "custom-promo-popup-closed-session-" + id,
            "1",
          );
        } catch (e) {}
      }

      let exitAnim = popup.dataset.exitAnimation || "customPopupExitZoom";
      const popupWrap =
        popup.querySelector(".custom-promo-popup-wrap") || popup;

      const overlay =
        popup.nextElementSibling &&
        popup.nextElementSibling.classList.contains(
          "custom-promo-popup-overlay",
        )
          ? popup.nextElementSibling
          : document.querySelector(".custom-promo-popup-overlay");

      if (overlay) {
        overlay.classList.remove("custom-promo-popup-overlay-active");
      }

      popupWrap.classList.remove(
        "customPopupOpenZoom",
        "customPopupOpenSlide",
        "customPopupOpenFade",
      );
      popupWrap.classList.add("custom-promo-popup-animated", exitAnim);

      popupWrap.addEventListener(
        "animationend",
        function () {
          popupWrap.classList.remove("custom-promo-popup-animated", exitAnim);
          popup.classList.remove("custom-promo-popup-open");
          document.body.classList.remove("custom-promo-popup-scroll-hidden");
          document.documentElement.classList.remove(
            "custom-promo-popup-scroll-hidden",
          );

          if (popup.dataset.reshowOnClose === "true") {
            var delay = parseFloat(
              popup.dataset.reshowDelayNumber ||
                popup.dataset.openDelayNumber ||
                15,
            );
            if (popup._reshowTimer) clearTimeout(popup._reshowTimer);
            popup._reshowTimer = setTimeout(function () {
              $this.openPopup(popup);
            }, delay * 1000);
          }
        },
        { once: true },
      );
    },

    acceptPopup: function (popup) {
      var id = popup && popup.dataset ? popup.dataset.id : "";
      if (!id) return;

      try {
        sessionStorage.setItem("custom-promo-popup-closed-session-" + id, "1");
      } catch (e) {}

      var keySpecific = "custom-promo-popup-accept-" + id;
      $this.setCookie(keySpecific, "1", { expires: 365 });

      try {
        localStorage.setItem(keySpecific, "1");
        sessionStorage.setItem(keySpecific, "1");
      } catch (e) {}
    },

    getCookie: function (name) {
      var matches = document.cookie.match(
        new RegExp(
          "(?:^|; )" +
            name.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, "\\$1") +
            "=([^;]*)",
        ),
      );
      return matches ? decodeURIComponent(matches[1]) : undefined;
    },

    setCookie: function (name, value, options) {
      options = options || {};
      options.path = options.path ?? "/";

      if (typeof options.expires === "number" && options.expires > 0) {
        options.expires = new Date(
          Date.now() + options.expires * 24 * 60 * 60 * 1000,
        ).toUTCString();
      }

      value = encodeURIComponent(value);
      var updatedCookie = `${name}=${value}`;

      for (var [propName, propValue] of Object.entries(options)) {
        if (typeof propValue !== "boolean") {
          updatedCookie += `; ${propName}=${propValue}`;
        } else if (propValue) {
          updatedCookie += `; ${propName}`;
        }
      }

      document.cookie = updatedCookie;
    },
  };

  function initApp() {
    adpCustomPromoPopup.init();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initApp);
  } else {
    initApp();
  }

  // Shopify Theme Customizer events
  document.addEventListener("shopify:section:load", (e) => {
    adpCustomPromoPopup.init();
    if (window.Shopify && window.Shopify.designMode) {
      const popup =
        (e.target.classList && e.target.classList.contains("custom-promo-popup") ? e.target : null) ||
        (e.target.querySelector && e.target.querySelector(".custom-promo-popup"));
      if (popup) {
        adpCustomPromoPopup.openPopup(popup);
      }
    }
  });

  document.addEventListener("shopify:section:select", (e) => {
    const popup =
      (e.target.classList && e.target.classList.contains("custom-promo-popup") ? e.target : null) ||
      (e.target.querySelector && e.target.querySelector(".custom-promo-popup"));
    if (popup && adpCustomPromoPopup.openPopup) {
      adpCustomPromoPopup.openPopup(popup);
    }
  });

  document.addEventListener("shopify:section:deselect", (e) => {
    const popup =
      (e.target.classList && e.target.classList.contains("custom-promo-popup") ? e.target : null) ||
      (e.target.querySelector && e.target.querySelector(".custom-promo-popup"));
    if (popup && adpCustomPromoPopup.closePopup) {
      adpCustomPromoPopup.closePopup(popup);
    }
  });

  document.addEventListener("shopify:block:select", (e) => {
    const target = e.target;
    const popup =
      target.classList && target.classList.contains("custom-promo-popup")
        ? target
        : target.closest(".custom-promo-popup") ||
          (target.querySelector && target.querySelector(".custom-promo-popup"));
    if (popup && adpCustomPromoPopup.openPopup) {
      adpCustomPromoPopup.openPopup(popup);
    }
  });

  document.addEventListener("shopify:block:deselect", (e) => {
    const target = e.target;
    const popup =
      target.classList && target.classList.contains("custom-promo-popup")
        ? target
        : target.closest(".custom-promo-popup") ||
          (target.querySelector && target.querySelector(".custom-promo-popup"));
    if (popup && adpCustomPromoPopup.closePopup) {
      adpCustomPromoPopup.closePopup(popup);
    }
  });

  document.addEventListener("shopify:section:unload", function () {
    document.body.classList.remove("custom-promo-popup-scroll-hidden");
    document.documentElement.classList.remove(
      "custom-promo-popup-scroll-hidden",
    );
  });
})();
